import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
  function LabReportOpAll(props) {
      const {appt_id} = useParams();
      const [viewlabdata,setViewLabData] = useState([]);
      const [labtestData,setLabTestData] = useState([]);
      const [fetchedResults, setFetchedResults] = useState([]);
      const [isLoading, setIsLoading] = useState(true);
      const [labDataArray, setLabDataArray] = useState([]);
      const [labData,setlabData] = useState([]);

useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(baseUrl + 'lab-report-all/' + appt_id + '/');
        setLabTestData(response.data);
        setIsLoading(false);
        const response3 = await axios.get(baseUrl+'lab-pay/'+appt_id);
        setlabData(response3.data);

      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [appt_id]);

  useEffect(() => {
    if (labtestData.length > 0) {
      fetchLabData();
    }
  }, [labtestData]);


async function fetchLabData() {
  const fetchedData = [];
  const allFetchedResults = [];

  for (const test of labtestData) {
    const ltestIds = test.ltest_id.split(',').map(item => item.trim());
    const results = test.results.split(',').map(item => item.trim());

    for (const ltestId of ltestIds) {
      try {
        const response = await axios.get(baseUrl + 'lab-test-view/' + ltestId + '/');
        fetchedData.push(response.data);

      } catch (error) {
        console.log(error);
      }
    }
    allFetchedResults.push(...results);
  }
 
   let flattendArray = fetchedData.flat()
  setViewLabData(flattendArray);
  setFetchedResults(allFetchedResults);
}
  if (isLoading) {
    return <div>Loading...</div>;
  }
   if (!labtestData || labtestData.length === 0) {
    return <div>No data available.</div>;
  }

const updatedLabbillData = viewlabdata.map((testsArray, testIndex) =>{
    let results = fetchedResults[testIndex];
    return (
      <tr key={`${testIndex + 1}`}>
        <td>{testsArray?.test}</td>
        <td>{results}</td>
        <td>{testsArray?.units}</td>
        <td>{testsArray?.ranges}</td>
      </tr>
    );
}
 
);
  return (
    <section>
      <div id="invoice-print">
      {labData.map((row, index) =>
          <div>
            <table border="2"  className="text-justify mt-4" width="100%" >
              <tr >
               <th className="mx-0 ps-5" rowSpan="10">
                    Name : {labtestData[0].pat.patient}
                       <br></br>
                    Consultant : Dr.{labtestData[0].cons.consultant}
                       <br></br>
                   Sample Date : {labData[0].add_date}
               </th>
               </tr>
               <tr >
               <th>
                        Age/Gender : {row.pat.age}/{row.pat.gender}
                           <br></br>
                        PID : {row.pat.pat_id}<br></br>
                        Report Date : {labtestData[0].sample_date}
               </th>
               </tr>
            </table>
          </div>
          )}
          <div>
            <table className="table table-bordered mt-4">
              <thead>
                <tr style={{borderColor: "#F2F2F2"}}>
                   <th align="left">Test</th>
                   <th align="left">Result</th>
                   <th align="left">Units</th>
                   <th align="left">Ranges</th>
                </tr>
              </thead>
              <tbody>
               {updatedLabbillData}
            </tbody>
            </table>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}>
           Print
          </button>
        </div>
    </section>
  );
  }
export default LabReportOpAll;

